import { ProjectChild, isProjectProductPosition } from "shared/types/Project"

export function getProductPositionTotal(
  variants: ProjectChild[] | null | undefined
): number {
  return (
    variants?.reduce(
      (total, item) =>
        (isProjectProductPosition(item)
          ? 1
          : getProductPositionTotal(item.children)) + total,
      0
    ) || 0
  )
}
